<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>color_lens</mat-icon></div>
          <mat-card-title>
            Produto
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-12" style="display: flex;">
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>ID</mat-label>
                    <input formControlName="id" matInput readonly>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Nome</mat-label>
                    <input formControlName="name" matInput placeholder="Digite seu nome" minlength="3"
                      maxlength="50" required>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Estoque</mat-label>
                    <input formControlName="stockQuantity" matInput>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Situação do produto</mat-label>
                    <mat-select formControlName="active" required>
                      <mat-option value="true">Ativo</mat-option>
                      <mat-option value="false">Inativo</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formulario.controls.active.hasError('required')">Status é obrigatório!</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12" style="display: flex;">
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Cód do Produto</mat-label>
                    <input maxlength="13" formControlName="productMaster" mask="separator.0" matInput
                      placeholder="ex: 0000000000000" (change)="buscarProduto()">
                  </mat-form-field>
                </div>
                <div class="col-10">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Produto Principal</mat-label>
                    <input matInput value="{{nameProduct}}" disabled>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12" style="display: flex;">
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Custo</mat-label>
                    <span matPrefix>R$ &nbsp;</span>
                    <input matInput formControlName="cost" mask="separator.2" thousandSeparator="."
                      placeholder="1.000,00" minlength="1" maxlength="6" required>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Venda Portaria</mat-label>
                    <span matPrefix>R$ &nbsp;</span>
                    <input matInput formControlName="pricePort" mask="separator.2" thousandSeparator="."
                      placeholder="1.000,00" minlength="1" maxlength="6" required>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Venda Entrega</mat-label>
                    <span matPrefix>R$ &nbsp;</span>
                    <input matInput formControlName="price" mask="separator.2" thousandSeparator="."
                      placeholder="1.000,00" minlength="1" maxlength="6" required>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Venda A Prazo</mat-label>
                    <span matPrefix>R$ &nbsp;</span>
                    <input matInput formControlName="priceReceivable" mask="separator.2" thousandSeparator="."
                      placeholder="1.000,00" minlength="1" maxlength="6" required>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12" style="display: flex;">
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>cEAN</mat-label>
                    <input matInput formControlName="cean" placeholder="0000000000000" minlength="1" maxlength="13">
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>NCM</mat-label>
                    <input matInput formControlName="ncm" placeholder="0000" minlength="1" maxlength="12">
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>CEST</mat-label>
                    <input matInput formControlName="cest" placeholder="00000000" minlength="1" maxlength="12">
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>CFOP</mat-label>
                    <input matInput formControlName="cfop" placeholder="0000" minlength="1" maxlength="4">
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>cEANTrib</mat-label>
                    <input matInput formControlName="ceanTrib" placeholder="0000000000000" minlength="1" maxlength="13">
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Código de Benefício Fiscal</mat-label>
                    <input matInput formControlName="cbenef" placeholder="00000000" minlength="1" maxlength="20">
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12" style="display: flex;">
                <div class="col-4">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Unidade Comercial</mat-label>
                    <mat-select formControlName="unidadeComercial" required>
                      <mat-option value="GALAO">GALÃO</mat-option>
                      <mat-option value="KG">QUILOGRAMA</mat-option>
                      <mat-option value="LATA">LATA</mat-option>
                      <mat-option value="LITRO">LITRO</mat-option>
                      <mat-option value="M">METRO</mat-option>
                      <mat-option value="PC">PEÇA</mat-option>
                      <mat-option value="POTE">POTE</mat-option>
                      <mat-option value="SACO">SACO</mat-option>
                      <mat-option value="UNID">UNIDADE</mat-option>
                      <mat-option value="VASIL">VASILHAME</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Unidade Tributaria</mat-label>
                    <mat-select formControlName="unidadeTributaria" required>
                      <mat-option value="GALAO">GALÃO</mat-option>
                      <mat-option value="KG">QUILOGRAMA</mat-option>
                      <mat-option value="LATA">LATA</mat-option>
                      <mat-option value="LITRO">LITRO</mat-option>
                      <mat-option value="M">METRO</mat-option>
                      <mat-option value="PC">PEÇA</mat-option>
                      <mat-option value="POTE">POTE</mat-option>
                      <mat-option value="SACO">SACO</mat-option>
                      <mat-option value="UNID">UNIDADE</mat-option>
                      <mat-option value="VASIL">VASILHAME</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Vinculo Adicional</mat-label>
                    <mat-select formControlName="vinculoAdicional" required>
                      <mat-option value="NENHUM">NENHUM</mat-option>
                      <mat-option value="GLP">Gás GLP</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12" style="display: flex;" *ngIf="formulario.value.vinculoAdicional == 'GLP'">
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Percentual do GLP derivado do petróleo</mat-label>
                    <input matInput formControlName="pglp" placeholder="0000000000000" minlength="1" maxlength="15">
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Percentual de Gás Natural Nacional</mat-label>
                    <input matInput formControlName="pgNn" placeholder="0000" minlength="1" maxlength="15">
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Percentual de Gás Natural Importado</mat-label>
                    <input matInput formControlName="pgNi" placeholder="00000000" minlength="1" maxlength="15">
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Valor de partida</mat-label>
                    <input matInput formControlName="valorPart" placeholder="0000" minlength="1" maxlength="15">
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="wow-form-acoes">
              <button type="button" mat-stroked-button (click)="voltarConsulta()">
                <mat-icon>arrow_back</mat-icon> Voltar
              </button>
              <button type="button" mat-stroked-button (click)="limparFormulario()">
                <mat-icon>insert_drive_file</mat-icon> Limpar
              </button>
              <button [disabled]="!formulario.valid" mat-raised-button color="primary" type="submit">
                <mat-icon>save</mat-icon> Salvar
              </button>
            </div>
          </form>
          <div class="esp-top">
            <div *ngIf="formulario.controls.name.errors && !formulario.controls.name.pristine"
              class="alert alert-warning" role="alert">
              Campo nome deve conter entre 3 e 50 caracteres!
            </div>
            <div *ngIf="formulario.controls.price.errors && !formulario.controls.price.pristine"
              class="alert alert-warning" role="alert">
              Verifique o preço informado!
            </div>
          </div>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
